import React, {useEffect, useMemo, useState} from "react";
import {Link} from "react-router-dom";
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay, Pagination} from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import {getBlogs} from "../../../utils/cms.utils";

const SimilarContent = ({tags = [], currentId}) => {
    const [blogs, setBlogs] = useState([]);

    /* =========================
       GET BLOGS FROM CMS CACHE
    ========================== */
    useEffect(() => {
        try {
            const data = getBlogs();
            setBlogs(Array.isArray(data) ? data : []);
        } catch (e) {
            console.error("SimilarContent CMS error:", e);
            setBlogs([]);
        }
    }, []);

    /* =========================
       FILTER RELATED BLOGS
    ========================== */
    const relatedBlogs = useMemo(() => {
        if (!Array.isArray(tags) || tags.length === 0) return [];

        return blogs
            .filter((item) => {
                if (currentId && String(item.id) === String(currentId)) {
                    return false; // ⛔ exclude current article
                }

                return (
                    Array.isArray(item.tags) &&
                    item.tags.some((tag) => tags.includes(tag))
                );
            })
            .slice(0, 8);
    }, [blogs, tags, currentId]);

    if (relatedBlogs.length === 0) return null;

    return (
        <div style={{marginTop: 70}}>
            <h4
                style={{
                    fontWeight: 800,
                    marginBottom: 24,
                    textAlign: "center",
                }}
            >
                Related Articles
            </h4>

            <Swiper
                modules={[Autoplay, Pagination]}
                slidesPerView="auto"
                spaceBetween={16}
                grabCursor
                autoplay={{
                    delay: 3500,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                }}
                style={{paddingBottom: 40}}
            >
                {relatedBlogs.map((item) => (
                    <SwiperSlide key={item.id} style={{width: 260}}>
                        <div
                            style={{
                                height: 150,
                                background: "#FFFFFF",
                                border: "2px solid #FF9209",
                                borderRadius: 12,
                                padding: "14px 16px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                            }}
                        >

                            {/* TITLE */}
                            <h6
                                style={{
                                    textDecoration: "none",
                                    fontWeight: 700,
                                    fontSize: 14,
                                    lineHeight: "1.35",
                                    margin: "6px 0",
                                    overflow: "hidden",
                                    display: "-webkit-box",
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: "vertical",
                                }}
                            >
                                <Link
                                    to={`/blog/${item.id}`}
                                    style={{color: "#0A2A55", textDecoration: "none",}}
                                >
                                    {item.title}
                                </Link>
                            </h6>

                            {/* CTA */}
                            <Link
                                to={`/blog/${item.id}`}
                                style={{
                                    fontSize: 12,
                                    fontWeight: 600,
                                    color: "#6B7280",
                                }}
                            >
                                Read →
                            </Link>
                        </div>
                    </SwiperSlide>
                ))}

                {/* SEE ALL */}
                <SwiperSlide style={{width: 260}}>
                    <div
                        style={{
                            height: 150,
                            border: "2px dashed #FF9209",
                            borderRadius: 12,
                            padding: "14px 16px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Link
                            to="/blog"
                            style={{
                                fontWeight: 800,
                                color: "#FF9209",
                                fontSize: 14,
                            }}
                        >
                            See Other Blogs →
                        </Link>
                    </div>
                </SwiperSlide>
            </Swiper>
        </div>
    );
};

export default SimilarContent;
